import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {DepartmentHealthRecommendedActionItem} from './DepartmentHealthRecommendedActionItem';
import {DepartmentHealthRecommendedActionsSkeleton} from './DepartmentHealthRecommendedActionsSkeleton';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import type {DepartmentHealthActionItem} from '../../types/DepartmentHealthTypes';
import {getDepartmentHealthActionSectionIcon} from '../../utils/DepartmentHealth/getDepartmentHealthActionItemIcon';

const cardSx = {
  border: '0.5px solid',
  borderColor: 'divider',
  borderRadius: '14px',
  px: 2.5,
  py: 2.25,
  mb: 2,
} as const;

const sectionTitleSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  fontSize: '13px',
  fontWeight: 600,
  color: 'text.primary',
  mb: 1.5,
} as const;

export interface Props {
  actionItems?: DepartmentHealthActionItem[];
  loading?: boolean;
}

export const DepartmentHealthRecommendedActions = ({actionItems, loading = false}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceDepartmentHealthPage.recommendedActions'});

  if (loading || !actionItems) {
    return <DepartmentHealthRecommendedActionsSkeleton />;
  }

  return (
    <EmpionPaper sx={cardSx} data-testid='department-health-recommended-actions'>
      <Box component='h2' sx={sectionTitleSx}>
        <Box component='span' sx={{color: 'text.secondary', display: 'flex', alignItems: 'center'}}>
          {getDepartmentHealthActionSectionIcon()}
        </Box>
        {t('title')}
        <Typography
          component='span'
          sx={{
            marginLeft: 'auto',
            fontSize: '11.5px',
            fontWeight: 400,
            color: 'text.secondary',
          }}
        >
          {t('subtitle')}
        </Typography>
      </Box>

      <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
        {actionItems.map((item, index) => (
          <DepartmentHealthRecommendedActionItem
            key={`${item.actionType}-${item.roleTitle ?? ''}-${index}`}
            item={item}
          />
        ))}
      </Box>
    </EmpionPaper>
  );
};
